module.exports = __webpack_public_path__ + "static/media/retro.7ca1dd18.jpg";